export class Country {
    id: number;
    name: string;
    description: string;
    countryCode:number;
   
}


